import { PublicFaqItem } from '~/types/public';

export const quadBikeFaq: PublicFaqItem[] = [
  {
    question: 'Каким образом быстро организовать перевозку квадроциклов с помощью вашей компании?',
    answer: 'Для быстрой организации перевозки квадрациклов Вам необходимо связаться с менеджерами компании Vozovoz, которые помогут подобрать необходимую технику и автомобиль для погрузки идальнейшей траспортировки квадрациклов, а также назовут сроки и стоимость перевозки.'
  },
  {
    question: 'Почему именно вашей компании стоит доверить перевозку квадроциклов?',
    answer: 'Компания Vozovoz имеет большой многолетний опыт по перевозке различных сложных транспортных средств, в том числе квадрациклов. Мы гарантируем сохранность вашей техники, предоставляя опытных специалистов, специализированное оборудование для погрузки и транспортировки, а также возможность страхования груза.'
  },
  {
    question: 'Какие меры безопасности применяются при перевозке квадроциклов вашей компанией?',
    answer: 'Многолетний опыт компании Vozovoz. Мы осуществляем тщательную фиксацию квадроциклов на прицепах, следим за их состоянием во время перевозки и используем надежное оборудование.'
  },
  {
    question: 'Какими типами транспортных средств и прицепов лучше всего перевозить квадроциклы?',
    answer: 'Для перевозки квадрациколов необходимо использовать специальные грузовые автомобили и прицепы. Компания Vozovoz распологает большим парком специализированного транспорта для транспортировки любых видов квадрациклов: <ul class="public-list"><li>открытая машина,</li> <li>растеновка,</li> <li>автомобиль с боковой загрузкой,</li> <li>автомобиль с верхней загрузкой.</li></ul> Выбрать наиболее подходящий вид транспорта можно при оформлении заявки в калькуляторе на сайте, в личном кабинете Vozovoz или в мобильном приложении.'
  }
]

export const pianoFaq: PublicFaqItem[] = [
  {
    question: 'Как обеспечивается безопасная перевозка пианино с вашей компанией?',
    answer: 'Наша компания имеет большой опыт по перевозке музыкальных инструментов, в том числе пианино. Для транспортировки мы используем специализированное оборудование и опытных специалистов. Чтобы при транспортировке ваше пианино не пострадало мы обязательно используем жёсткую упаковку. По правилам Vozovoz клавишные инструменты не принимаются к перевозке без данного типа упаковки. Упаковать груз можно самостоятельно или воспользоваться услугами компании.'
  },
  {
    question: 'Какие виды пианино вы можете перевезти?',
    answer: 'Мы обеспечиваем перевозку различных видов пианино, включая рояли, концертные гранды и вертикальные инструменты.'
  },
  {
    question: 'Какие услуги вы предоставляете в рамках перевозки пианино?',
    answer: 'Компания Vozovoz осуществляет целый ряд сопутствующих (упаковка, погрузка, перевозка, разгрузка) и дополнительных услуг по транспортировке музыкальных инструментов. Так, например, мы предлагаем нашим клиентам воспользоваться потоковым или традиционным страхованием грузов от Vozovoz для гарантии материального возмещения возможных убытков.'
  },
  {
    question: 'Сколько времени занимает перевозка пианино с вашей компанией?',
    answer: 'Время перевозки пианино зависит от расстояния и маршрута, но мы всегда стремимся к сокращению сроков доставки, не принебрегая качеством предоставляемых услуг и безопасностью перевозки.'
  },
  {
    question: 'Как мне узнать стоимость перевозки моего пианино с вашей компанией?',
    answer: 'Вы можете запросить бесплатный расчет стоимости на нашем сайте или связаться с нашими менеджерами для получения подробной информации о ценах и условиях перевозки пианино. Кроме того при оформлении заявки на доставку пианино по городу или между городами и странами важно указать точные габариты и вес инструмента. Так как именно эти факторы являются основой формирования цены на перевозку. То же касается и комплекса дополнительных услуг.'
  },
  {
    question: 'Могу ли я заказать услугу перевозки пианино на определенную дату и время?',
    answer: 'Вы можете заказать услугу по перевозке пианино на любую удобную вам дату и время.'
  },
]

export const motorcycleFaq: PublicFaqItem[]  = [
  {
    question: 'Как можно организовать перевозку мотоцикла с вашей компанией?',
    answer: 'Для быстрой организации перевозки мотоцикла Вам необходимо связаться с менеджерами компании Vozovoz, которые помогут подобрать необходимую технику и автомобиль для погрузки и дальнейшей траспортировки, а также назовут сроки и стоимость перевозки.'
  },
  {
    question: 'Какие виды мотоциклов вы способны перевозить?',
    answer: 'Мы можем перевозить разные типы мотоциклов, включая круизеры, спортивные, туристические и другие.'
  },
  {
    question: 'Как обеспечивается безопасность моего мотоцикла во время перевозки?',
    answer: 'Компания Vozovoz действует согласно установленным правилам перевозки скутеров и мотоциклов, которые подразумевают наличие прочной упаковки груза и его надёжной фиксации. <ul class="public-list"><li>Согласно правилам Vozovoz, перевозка мотоцикла или скутера не может производиться без жёсткой упаковки</li> <li>Для фиксации могут использоваться трапы или крепёжный ремень.</li></ul>'
  },
  {
    question: 'Сколько времени обычно требуется на перевозку мотоцикла?',
    answer: 'Время доставки зависит от расстояния и маршрута, но мы всегда стремимся к быстрой и надежной доставке.'
  },
  {
    question: 'Какие документы или формальности нужны для организации перевозки мотоцикла?',
    answer: 'Вам может потребоваться предоставить копии документов на мотоцикл, а также заполнить необходимые формы для транспортировки.'
  },
  {
    question: 'Как мне узнать стоимость перевозки моего мотоцикла с вашей компанией?',
    answer: 'Для быстрого расчета стоимости вы можете связаться с менеджерами Vozovoz, предоставив всю необходимую для рассчёта информацию. Также Вы можете рассчитать стоимость перевозки самостоятельно, воспользовавшись калькулятором рассчёта стоимости на сайте или в мобильном приложении Vozovoz. Обратите внимание, что для точного рассчёта перевозки необходимо верно указать параметры вашего груза и необходимые дополнительные услуги.'
  },
  {
    question: 'Могу ли я заказать услугу перевозки мотоцикла на определенную дату и время?',
    answer: 'Да, Вы можете заказать услугу по перевозке мотоцикла на любую удобную вам дату и время.'
  },
  {
    question: 'Вы перевозите мотоциклы из других стран?',
    answer: 'Транспортная компания Vozovoz реализует перевозку мототехники между городами России, Беларуси, Казахстана и Киргизии, вне зависимости от её конфигурации. Доступен также ряд дополнительных услуг, для того, чтобы удобнее и безопаснее отправить и получить технику.'
  }
]

export const furnitureFaq: PublicFaqItem[] = [
  {
    question: 'Каким образом можно организовать перевозку мебели с вашей компанией?',
    answer: 'Вы можете самостоятельно создать заявку и рассчитать цену на перевозку мебели онлайн за несколько минут: в калькуляторе на сайте или в мобильном приложении Vozovoz.'
  },
  {
    question: 'Какие виды мебели вы принимаете к перевозке?',
    answer: 'Мы можем перевозить различные виды мебели, включая мебель для дома, офиса, а также антиквариат и специализированные предметы. К перевозке принимаются: матрасы, мягкая мебель, мебель из металла, мебель из пластика, мебельная фурнитура'
  },
  {
    question: 'Как обеспечивается безопасность и сохранность мебели во время перевозки?',
    answer: 'Мы используем специальную жётскую обрешетку для дополнительной защиты мебели, а также фиксируем её при транспортировке, чтобы предотвратить повреждения.'
  },
  {
    question: 'Какие документы или формальности нужны для организации перевозки мебели?',
    answer: 'Вам может потребоваться предоставить информацию о грузе и маршруте, а также заполнить необходимые транспортные документы.'
  },
  {
    question: 'Сколько времени обычно требуется на перевозку мебели с вашей компанией?',
    answer: 'Время доставки зависит от расстояния и логистики, но мы всегда стараемся соблюдать сроки и предоставлять быструю и надежную доставку.'
  },
  {
    question: 'Как мне узнать стоимость перевозки моей мебели с вашей компанией?',
    answer: 'Вы можете рассчитать стоимость перевозки самостоятельно, воспользовавшись калькулятором рассчёта стоимости на сайте или в мобильном приложении Vozovoz. Обратите внимание, что для точного рассчёта перевозки необходимо верно указать параметры вашего груза и необходимые дополнительные услуги.'
  },
  {
    question: 'Могу ли я заказать услугу перевозки мебели на определенную дату и время?',
    answer: 'Да, мы готовы согласовать дату и время перевозки в соответствии с вашими пожеланиями и расписанием.'
  },
]

export const boatFaq: PublicFaqItem[] = [
  {
    question: 'Каким образом можно организовать перевозку лодок с вашей компанией?',
    answer: 'Для организации перевозки лодок Вам необходимо связаться с менеджерами компании Vozovoz, которые помогут подобрать необходимую технику и автомобиль для погрузки и дальнейшей траспортировки, а также назовут сроки и стоимость перевозки.'
  },
  {
    question: 'Какие виды лодок вы способны перевозить?',
    answer: 'Мы можем перевозить различные виды лодок, включая моторные лодки, парусные яхты, каяки и другие водные средства.'
  },
  {
    question: 'Как обеспечивается безопасность и сохранность лодок во время перевозки?',
    answer: 'Компания Vozovoz имеет большой опыт по перевозке лодок разного типа. Для их транспортировки мы чаще всего используем гидроборт, который является одним из наиболее подходящих средств. Это обусловлено тем, что основной механизм устройства используется для подъёма груза с земли до уровня пола фургона. Использование гидроборта также позволит существенно сократить время на погрузо-разгрузочные работы и повысить уровень их безопасности. Мы используем специализированные прицепы и оборудование для надежной фиксации и защиты лодок от повреждений во время транспортировки.'
  },
  {
    question: 'Сколько времени обычно требуется на перевозку лодок с вашей компанией?',
    answer: 'Время доставки лодок зависит от расстояния и маршрута, но мы всегда стараемся соблюдать сроки и обеспечивать быструю и надежную доставку.'
  },
  {
    question: 'Как мне узнать стоимость перевозки моей лодки с вашей компанией?',
    answer: 'Вы можете рассчитать стоимость перевозки самостоятельно, воспользовавшись калькулятором рассчёта стоимости на сайте или в мобильном приложении Vozovoz. Главным фактором, влияющим на цену транспортировки лодки, являются её габариты, вес и объём. В случае, если изначально эти параметры были введены в форму расчёта на сайте, в личном кабинете или мобильном приложении неправильно, то общая стоимость будет изменена после перемера груза на терминале компании.'
  },
  {
    question: 'Могу ли я заказать услугу перевозки лодки на определенную дату и время?',
    answer: 'Да, Вы можете согласовать необходимую дату перевозки и фиксированное время получения в соответствии с вашими пожеланиями.'
  }
]
